<template>
  <div class="img-fab-wrapper">
    <label class="img-fab button is-rounded is-primary">
      <!-- <span>lololodsdeasdewasdxs</span> -->
      <span class="icon is-large p-0 m-0">
        <i v-if="isLoading" class="fa-lg fa-solid fa-spinner spinner" />
        <i v-else class="fa-lg fa-solid fa-camera" />
      </span>
      <input
        :type="type"
        :multiple="multiple"
        :accept="accept"
        @change="$emit('selected-images', $event)"
      />
    </label>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      default: 'file',
      type: String,
    },
    multiple: {
      default: true,
      type: Boolean,
    },
    accept: {
      default: 'image/*',
      type: String,
    },
    isLoading: {
      default: false,
      type: Boolean,
    },
  },
}
</script>

<style lang="scss" scoped>
$button-width: 55px;
.img-fab-wrapper {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: var(--z-fab);

  label.img-fab.button {
    // position: relative;
    width: $button-width;
    height: $button-width;
    border-radius: $button-width;
    margin: 1rem;
    padding: 0;
    box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
      0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);

    input {
      // position: absolute;
      // // display: none;
      visibility: hidden;
      width: 0;
      height: 0;
      border: 0;
      padding: 0;
    }
  }
}
</style>
